import { useCallback, useRef } from 'react';
import { THandleSubmit } from './types';
import { IHandleSubmitParams } from '../types';
import { validateFormInputs } from '../helpers/validateFormInputs';
import { isFunction } from 'lodash';
import { constructSubmitData } from '../helpers/constructSubmitData';

export const useHandleSubmit = ({
  inputs,
  setInputs,
  context,
}: IHandleSubmitParams): THandleSubmit => {
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;

  return useCallback(
    submitCallback => {
      const current = inputsRef.current;
      const validatedInputs = validateFormInputs(current, context);
      setInputs(validatedInputs);
      const isValid = !Object.values(validatedInputs).filter(input => input.errors?.length).length;
      if (isValid && submitCallback && isFunction(submitCallback)) {
        const data = constructSubmitData(validatedInputs);
        submitCallback(data);
      }
    },
    [context, setInputs]
  );
};
